import { MenuMinimizeIcon, MenuMaximizeIcon } from '@panwds/icons';
import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useIntl } from 'react-intl';

function Collapse({ changeCollapse, collapsed, subnavOpened }) {
    const intl = useIntl();
    const classes = classNames("tw-flex tw-m-0 tw-items-center tw-relative tw-pl-2 tw-py-0 tw-h-12 tw-border-none", "spf-nav-bg-bg spf-nav-text-default-color", "group-hover:spf-nav-bg-hover-bg group-hover:spf-nav-text-hover-color", "active:spf-nav-bg-active-bg active:spf-nav-text-active-color", collapsed ? "tw-pr-1 tw-h-9 tw-w-12" : "tw-pr-4");
    return (React.createElement("button", { "data-metrics": "primary-nav-collapse-bar", "data-testid": "collapseBar", className: classes, onClick: changeCollapse, "aria-label": collapsed
            ? intl.formatMessage({
                defaultMessage: "Expand Navigation",
                id: "ArQZ2n",
                description: "Navigation button to expand",
            })
            : intl.formatMessage({
                defaultMessage: "Collapse Navigation",
                id: "chAh86",
                description: "Navigation button to collapse",
            }) }, !collapsed && !subnavOpened ? (React.createElement("div", { className: `tw-border-solid tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t spf-nav-border-separator-color tw-my-2 tw-h-full tw-w-64 tw-flex tw-items-center` },
        React.createElement("div", { className: `tw-box-border tw-ml-2 tw-pr-6 tw-flex tw-items-center` },
            React.createElement(MenuMinimizeIcon, { size: "lg", className: "tw-box-border tw-inline-block" })),
        !subnavOpened && React.createElement("div", { className: `tw-box-border tw-pr-3` }, "Toggle Menu"))) : (React.createElement("div", { className: `tw-border-solid tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t spf-nav-border-separator-color tw-h-full tw-w-9 tw-px-2 tw-pb-2 tw-pt-3` },
        React.createElement(MenuMaximizeIcon, { size: "lg", className: `tw-relative tw-top-1` })))));
}

export { Collapse };
//# sourceMappingURL=Collapse.esm.js.map
